


















































import Vue from 'vue'
import RadioCheckGroup from '@/UI/Shared/RadioCheckGroup.vue'
import DisabledTextInput from '@/UI/Shared/DisabledTextInput.vue'
import ProcedureDetailForm from '@/UI/Procedures/ProcedureDetailForm.vue'
import { VueInputCheckRadio } from '@/UI/Shared/VueInputCheckRadio'
import { ProcedureDto } from '@/Application/Procedures'

// Tipos
// PN Procedemento Negociado
// PX Poxa
// AD Alleamento directo

export default Vue.extend({
  name: 'ProcedureForm',
  components: {
    RadioCheckGroup,
    DisabledTextInput,
    ProcedureDetailForm
  },
  props: {
    resfor: {
      type: String,
      required: true
    },
    procedure: {
      type: Object as () => ProcedureDto,
      required: true
    }
  },
  data () {
    return {
      inputClasses: ['col-xs-12', 'col-sm-6', 'col-md-4'],
      expanded: true
    }
  },
  computed: {
    radiosList (): VueInputCheckRadio[] {
      const radiosList = [
        {
          id: 'tipoProcementoAberto',
          label: this.$t('subasta.procedure.tipoProcementoAberto').toString(),
          value: 'PX',
          name: 'tipoProcedemento',
          checked: false
        },
        {
          id: 'tipoProcedementoNegociando',
          label: this.$t('subasta.procedure.tipoProcedementoNegociando').toString(),
          value: 'PN',
          name: 'tipoProcedemento',
          checked: false
        },
        {
          id: 'tipoProcedementoAlleo',
          label: this.$t('subasta.procedure.tipoProcedementoAlleo').toString(),
          value: 'AD',
          name: 'tipoProcedemento',
          checked: false
        }
      ]
      return radiosList
    },
    procedureMounted (): ProcedureDto {
      return new ProcedureDto(
        this.procedure.procedureId,
        this.procedure.procedureType,
        this.procedure.procedureStatus,
        this.procedure.provinceCode,
        this.procedure.publishDate,
        this.procedure.dogaUrl,
        this.procedure.dogaNumber,
        this.procedure.limitDate,
        this.procedure.celebrationPlace,
        this.procedure.celebrationDate,
        this.procedure.celebrationTime
      )
    }
  },
  methods: {
    onExpandDetailProcedure (): void {
      this.expanded = !this.expanded
    }
  }
})
